// extracted by mini-css-extract-plugin
module.exports = {"errorHolder":"ErrorBar_errorHolder__2S4TZ"};